import React, { FC } from 'react'
import styled from 'styled-components'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Navigation } from '@ucheba/ui/components/Navigation/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Collapse, CollapseItem } from '@ucheba/ui/components/Collapse/desktop'
import { capitalizeFirstLetter } from '@ucheba/utils/helpers/string'
import { Button } from '@ucheba/ui/components/Button/desktop'
import Icon from '@ucheba/ui/icons/icon__arrow-right_circle-outline.svg'
import { sv } from '@ucheba/utils/helpers/styles/variables'

import { IInstitutionPrograms } from '../types'
import { useInstitutionPrograms } from '../bll'
import Programs from '../../Programs/desktop'

const Block = styled.div``

const ButtonBlock = styled.div`
  padding-top: 20px;
  border-top: 1px solid ${sv.color.gray9};
`

const InstitutionPrograms: FC<IInstitutionPrograms> = (props) => {
  const { id, showEducationalInstitutionAddedNotification = false } = props

  const { items, activeIndex, programs, onClick, programType, programTypeName } =
    useInstitutionPrograms({
      id,
    })

  if (!programs?.items.length) return null

  return (
    <Block>
      <Heading h2='Программы обучения' spacing='large' />

      <Navigation items={items} activeIndex={activeIndex} onClick={onClick} />

      <Spacing spacing='xlarge' />

      <Collapse>
        {programs &&
          programs.items.map((item) => {
            return (
              <CollapseItem
                title={capitalizeFirstLetter(item.tag.name)}
                key={item.tag.id}
                marginLeft={48}
              >
                <Programs
                  showEducationalInstitutionAddedNotification={
                    showEducationalInstitutionAddedNotification
                  }
                  items={item.programs}
                  programType={programType}
                />

                {item.programs.length === 2 && item.total > 2 && (
                  <ButtonBlock>
                    <Button
                      block
                      color='blue'
                      EndIcon={<Icon color='blue' width='24px' />}
                      justifyContent='space-between'
                      view='link'
                      href={
                        programTypeName
                          ? `/uz/${id}/programs/${programTypeName}?tagIds[]=${item.tag.id}`
                          : `/uz/${id}/programs?tagIds[]=${item.tag.id}`
                      }
                    >
                      Все программы сферы
                    </Button>
                  </ButtonBlock>
                )}
              </CollapseItem>
            )
          })}
      </Collapse>

      <Spacing spacing='uxlarge' />
    </Block>
  )
}

export default InstitutionPrograms
